import { Button, IconButton } from '@material-ui/core'
import { Close as CloseIcon } from '@material-ui/icons'
import { SnackbarKey } from 'notistack'
import React, { FC } from 'react'
import styled from 'styled-components'

export interface PrescriptionToastActionsProps {
  snackbarKey: SnackbarKey
  dismissToast: (snackbarKey: SnackbarKey) => void
  hideLink?: boolean
  onLinkClick?: () => void
}

const CloseButton = styled(IconButton)`
  margin-left: 10px;

  &.MuiIconButton-root:hover {
    background-color: rgba(255, 255, 255, 0.3);
  }
`

export const getPrescriptionToastActions = (
  props: Omit<PrescriptionToastActionsProps, 'snackbarKey'>,
) => {
  const Actions = (snackbarKey: SnackbarKey) => {
    return (
      <PrescriptionToastActions
        snackbarKey={snackbarKey}
        hideLink={props.hideLink}
        onLinkClick={props.onLinkClick}
        {...props}
      />
    )
  }
  return Actions
}

export const PrescriptionToastActions: FC<PrescriptionToastActionsProps> = ({
  snackbarKey,
  dismissToast,
  hideLink,
  onLinkClick,
}) => {
  return (
    <>
      {!hideLink && (
        <Button
          style={{ color: 'white' }}
          onClick={() => {
            if (onLinkClick) {
              onLinkClick()
            }
          }}
        >
          Undo
        </Button>
      )}
      <CloseButton
        size="small"
        aria-label="close"
        style={{ color: '#000000' }}
        onClick={() => dismissToast(snackbarKey)}
      >
        <CloseIcon fontSize="small" />
      </CloseButton>
    </>
  )
}
